module.exports = __webpack_public_path__ + "img/sweet_active.c008e1ea.png";